import { render } from "./Logo.vue?vue&type=template&id=9c74e4f8&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=9c74e4f8&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c74e4f8"]])

export default __exports__